import { Typography } from "@material-ui/core";
import React from "react";
import FlexiForm, { Fields } from "../../FlexiComponents/FlexiForm";
import Grid from "@material-ui/core/Grid/Grid";

const StuckAfterOffer = ({ onSubmit, formId }) => {
  const secondSectionRadios = [
    {
      fieldType: "radio",
      name: `quest2`,
      label: "1",
      value: "1"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "2",
      value: "2"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "3",
      value: "3"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "4",
      value: "4"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "5",
      value: "5"
    }
  ];

  const thirdSectionRadios = [
    [
      {
        fieldType: "radio",
        name: `quest3`,
        label: "További információ az ajánlatról",
        value: "a"
      }
    ],
    [
      {
        fieldType: "radio",
        name: `quest3`,
        label: "Ügyfélszolgálati segítség",
        value: "b"
      }
    ],
    [
      {
        fieldType: "radio",
        name: `quest3`,
        label: "Egyszerűbb folyamat",
        value: "c"
      }
    ],
    [
      {
        fieldType: "radio",
        name: `quest3`,
        label: "Jobb feltételek vagy kedvezmények",
        value: "d"
      }
    ],
    [
      {
        fieldType: "radio",
        name: `quest3`,
        label: "Nem érdekel a továbbiakban",
        value: "e"
      }
    ]
  ];
  const fifthSectionRadios = [
    [
      {
        fieldType: "radio",
        name: `quest5`,
        label: "1",
        value: "1"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "2",
        value: "2"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "3",
        value: "3"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "4",
        value: "4"
      },
      {
        fieldType: "radio",
        name: `quest5`,
        label: "5",
        value: "5"
      }
    ]
  ];
  return (
    <>
      <FlexiForm
        id={formId}
        FinalFormFormProps={{
          onSubmit
        }}
        render={({ values }) => (
          <div>
            <Typography variant={"h5"}>
              Mi volt az oka annak, hogy nem folytattad a folyamatot az ajánlat
              megtekintése után?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem értettem az ajánlat részleteit",
                      value: "a"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Túl bonyolult volt a folyamat",
                      value: "b"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem találtam elég vonzónak az ajánlatot",
                      value: "c"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Technikai problémába ütköztem",
                      value: "d"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Más ok",
                      value: "e"
                    }
                  ]
                ]}
              />
              {values?.quest1 === "e" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText1`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest1 !== "e"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mennyire volt érthető az ajánlat tartalma? (1 - egyáltalán nem, 5
              - érthető volt)
            </Typography>
            <Grid item xs={6}>
              <Fields config={[secondSectionRadios]} />
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mi segítene abban, hogy folytasd a folyamatot?
            </Typography>
            <Grid item xs={6}>
              <Fields config={thirdSectionRadios} />
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Tapasztaltál-e technikai problémát az ajánlat megtekintése után?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "nem",
                      value: "a"
                    },
                    {
                      fieldType: "radio",
                      name: `quest4`,
                      label: "igen",
                      value: "b"
                    }
                  ]
                ]}
              />
              {values?.quest4 === "b" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText2`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest4 !== "b"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mennyire valószínű, hogy a jövőben újra megfontolnád ezt az
              ajánlatot? (1 - egyáltalán nem, 5 - valószínű)
            </Typography>
            <Grid item xs={6}>
              <Fields config={fifthSectionRadios} />
            </Grid>
          </div>
        )}
      />
    </>
  );
};

export default StuckAfterOffer;
